export enum EngagementMeetingsPhase {
    NotStarted = 0,
    ProvideAvailability = 1,
    AgreeOnTimes = 2,
    MeetingsPeriod = 3,
    Completed = 4,
}

export const EngagementMeetingsPhases = [
    { id: EngagementMeetingsPhase.NotStarted, name: 'Not Started' },
    { id: EngagementMeetingsPhase.ProvideAvailability, name: 'Provide Availability' },
    { id: EngagementMeetingsPhase.AgreeOnTimes, name: 'Agree On Times' },
    { id: EngagementMeetingsPhase.MeetingsPeriod, name: 'Meetings Period' },
    { id: EngagementMeetingsPhase.Completed, name: 'Completed' },
];